import GoogleMapsApiLoader from "google-maps-api-loader";

import config from './constants';

var mapConfig = {
    apiKey: config.firebaseConfig.apiKey,
    libraries: ['places'],
};
var mapSettings = {
    clickableIcons: false,
    streetViewControl: false,
    panControlOptions: false,
    gestureHandling: "cooperative",
    mapTypeControl: false,
    zoomControlOptions: {
        style: "SMALL"
    },
    zoom: 5,
    minZoom: 2,
    maxZoom: 8,
};

const googleMapApi = GoogleMapsApiLoader(mapConfig);

export { googleMapApi, mapSettings };